import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PublicHeader from "../components/header";
import {
  isValidEmail,
  isValidMobileNumber,
  isValidMobileNumberWithcode,
} from "../components/ValidationServices";
import APIService from "../components/postServices";
import { showToast } from "../components/toastServices";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { ToastContainer } from "react-toastify";
import { formatNumber } from "../components/DateFormatServices";
import { formatNumberWithCommas, removeCountryCode } from "../utils/utils";
import grayQuestLogo from "../assets/grayquest-logo.png";
import ccAvenueLogo from "../assets/ccavenue-logo.png";
import { useEMIPlans } from "../components/grayGuestApi.service";
import NewArv from "../assets/New.png";
import GrayQuestModal from "../payment/GrayQuestModal";
import Preloader from "../components/Preloader";
import InlinePreloader from "../components/InlinePreloader";

const breadcrumb = [
  { label: "Entrance Exam Result", url: "/entranceExamResult" },
];

function RegPay() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const [ApplicationData, setApplicationData] = useState(null);
   const [grCloseFlag, setGrCloseFlag] = useState(1);
 

   // Then add these state variables inside your component
const [modalVisible, setModalVisible] = useState(false);
const [modalTitle, setModalTitle] = useState("");
const [modalMessage, setModalMessage] = useState("");
const [modalSeverity, setModalSeverity] = useState("info");

   // 2. Add an additional loading state specific for the refresh operation
const [refreshLoading, setRefreshLoading] = useState(false);
// 1. Add persistent DOB storage with localStorage
// Add this near the top of your component after the other state definitions:
const [StudentData, setStudentData] = useState(null);

 

const [dobVerificationData, setDobVerificationData] = useState({});
const [PaymentFormData, setPaymentFormData] = useState({});
const [persistentDob, setPersistentDob] = useState(() => {
  // Try to get saved DOB from localStorage
  const savedDob = localStorage.getItem('applicationDob');
  return savedDob || "";
});


   // const userName = useSelector(selectFirstName) ;
     const { emiPlans, getEMIPlans, totalEMIAmount } = useEMIPlans();
   
     const ccAvenuePaymentOptions = [
       { value: "OPTCRDC", label: "Credit Card" },
       { value: "OPTDBCRD", label: "Debit Card" },
       { value: "OPTNBK", label: "Net Banking" },
       { value: "OPTUPI", label: "UPI" },
     ];
   
     const [paymentMethodData, setPaymentMethod] = useState({
       paymentMethod: "ccAvenue",
     });
   
     const handleCardClick = (option) => {
       setPaymentMethod({
         ...paymentMethodData,
         paymentMethod: option,
       });
     };
   
     const paymentMethodChange = (e) => {
       setPaymentMethod({
         ...paymentMethodData,
         paymentMethod: e.value,
       });
     };
  // Use a single useEffect to handle setting ApplicationData and redirection
  useEffect(() => {
    const data = location.state?.data||JSON.parse(localStorage.getItem("selectedStudentEntrance"));
 
    if (data) {
      setApplicationData(data);
 
    } else {
      navigate("/");
    }
  }, [location.state, navigate]);
//,ApplicationData ,StudentData 
 
  // ApplicationData
 


  //  GrayQuest
  // 1. Update the script loading useEffect
    useEffect(() => {
      // Load the ERP SDK script
      const loadScript = () => {
        return new Promise((resolve, reject) => {
          const id = "gqerp-jssdk";
          if (document.getElementById(id)) {
            resolve(); // Script already loaded
            return;
          }

          const script = document.createElement("script");
          script.async = true;
          script.type = "text/javascript";
          script.src = process.env.REACT_APP_EMI_URL;
          script.id = id;

          script.onload = () => {
            // Wait a short time to ensure SDK initialization completes
            setTimeout(() => {
              if (window.GqErpSDK) {
                console.log("GqErpSDK loaded successfully");
                resolve();
              } else {
                console.error("GqErpSDK failed to initialize");
                reject();
              }
            }, 500);
          };

          script.onerror = () => {
            console.error("Failed to load GqErpSDK script");
            reject();
          };

          const firstScript = document.getElementsByTagName("script")[0];
          firstScript.parentNode.insertBefore(script, firstScript);
        });
      };

      // Call the loadScript function immediately, not dependent on window.load
      loadScript()
        .then(() => {
          console.log("GqErpSDK ready to use");
        })
        .catch((error) => {
          console.error("Error loading GqErpSDK:", error);
        });

      // Set up event listeners
      const handlePopupClose = (e) => {
        console.log("GQ Popup Close", e.gqData);
        setGrCloseFlag(grCloseFlag + 1);
        
        // Show modal with information about the popup closing
        // setModalTitle("Payment Window Closed");
        // setModalMessage("The payment window has been closed. Your session has been refreshed.");
        // setModalSeverity("info");
        // setModalVisible(true);
        // hideModal();
        VerifyDobForrefresh();
        
      };

      const handleActivity = (e) => {
        console.log("GQ Activity = ", e);
      };

      const handleSuccess = (e) => {
        console.log("GQ SUCCESS = ", e);
  
        // Show success modal
        setModalTitle("Payment Successful");
        setModalMessage(
          e.gqData?.message || 
          "Your payment has been processed successfully! A confirmation email will be sent to your registered email address."
        );
        setModalSeverity("success");
        setModalVisible(true);
        hideModal();
 
  
      };

      const handleError = (e) => {
        console.log("GQ Error = ", e.gqData);
  
        // Show error modal
        setModalTitle("Payment Error");
        setModalMessage(
          e.gqData?.error?.message || 
          "There was an error processing your payment. Please try again or contact support."
        );
        setModalSeverity("error");
        setModalVisible(true);
        hideModal();
       
      };

      document.addEventListener("onGqPopupClose", handlePopupClose);
      document.addEventListener("onGqActivity", handleActivity);
      document.addEventListener("onGqSuccess", handleSuccess);
      document.addEventListener("onGqError", handleError);

      // Clean up event listeners when component unmounts
      return () => {
        document.removeEventListener("onGqPopupClose", handlePopupClose);
        document.removeEventListener("onGqActivity", handleActivity);
        document.removeEventListener("onGqSuccess", handleSuccess);
        document.removeEventListener("onGqError", handleError);
      };
    }, []);
  //  end GrayQuest
  
 
// 3. Modify the useEffect that sets up dobVerificationData to use persistentDob
useEffect(() => {
 
  if (ApplicationData  ) {
    setDobVerificationData({
      ApplicationNo: ApplicationData.applicationNo,
      Dob: persistentDob, // Use the persistent DOB instead of empty string
      academicYear: ApplicationData.academicYear,
    });

    setPaymentFormData({
      Amount: ApplicationData && ApplicationData.classAmount,
      BillingName: ApplicationData.addressee
        ? ApplicationData.addressee
        : ApplicationData.fatherName
        ? ApplicationData.fatherName
        : ApplicationData.motherName, // Parent name
      BillingAddress: "",
      BillingCity: "",
      BillingState: "",
      BillingZip: "",
      BillingCountry: "",
      BillingTel: ApplicationData.phoneNumber,
      BillingEmail: ApplicationData.emailAddress,
      MerchantParam1: "Admission Fee", // Company ID
      MerchantParam2: "", // School ID
      MerchantParam3: ApplicationData.name, //Student name
      MerchantParam4: "", // Fee2
      MerchantParam5: ApplicationData.applicationNo, // App no
      CustomerIdentifier: ApplicationData.applicationNo,
      paymentOption: "",
      AcademicYear: ApplicationData.academicYear,
      Class: ApplicationData.class,
    });
  }
}, [ApplicationData]);

  const [CCAvenuePaymentSetup, setCCAvenuePaymentSetup] = useState();

  useEffect(() => {
    APIService.get(`/CCAvenuePayment/CCAvenuePaymentSetup`)
      .then((response) => {
        setCCAvenuePaymentSetup(response.data.dataSet);
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
      });
  }, []);
 

  const [UserformError, setFormError] = useState({});
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState({});
  const [verify, setVerify] = useState(false);
  const [selectedDob, setSelectedDob] = useState(null);

  const UserformDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setDobVerificationData({
      ...dobVerificationData,
      [name]: value,
    });

// If it's the DOB field, also update our persistent storage
if(name === "Dob") {
  setSelectedDob(value);
  setPersistentDob(value);
  localStorage.setItem('applicationDob', value);
}

    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        name === "emailAddress"
          ? value !== "" && !isValidEmail(value)
          : !isValidMobileNumber(value),
    };
    setErrors(newErrors);
  };

  const PaymentformDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setPaymentFormData({
      ...PaymentFormData,
      [name]: value,
    });

    // Perform validation on the fly and update the errors state
    const newErrors = {
      ...errors,
      [name]:
        name === "BillingEmail"
          ? value !== "" && !isValidEmail(value)
          : name === "BillingTel"
          ? value !== "" && !isValidMobileNumber(value)
          : "",
    };

    setErrors(newErrors);
  };

  const handleError = (error, input) => {
    setFormError((prevState) => ({ ...prevState, [input]: error }));
    setError(true);
  };

   

  const VerifyDob = async (e) => {
    e.preventDefault();
     // Set the refresh loading state to true before starting the operation
  setRefreshLoading(true);
    setLoading(true);
    let isValid = true;
    const dob = dobVerificationData.Dob;

    if (!dob) {
    
      handleError("Please insert date of birth", "Dob");
      isValid = false;
      setLoading(false);
      setRefreshLoading(false);
    }

    if (isValid) {
      try {

         // After verifying, save to persistent storage
    setPersistentDob(dob);
    localStorage.setItem('applicationDob', dob);

        const response = await APIService.Post(
          // `/SelectionProcess/VerifyDateOfBirth`,
          `/SelectionProcess/ApplicantDobVerification`,
          dobVerificationData
        );
        
        if (response.responseCode === 1) {
          setStudentData(response.dataSet);
          
          setPaymentFormData({
            ...PaymentFormData,
            Amount: response.dataSet.classAmount,
          });
          getEMIPlans(response.dataSet && response.dataSet.classAmount); 
          setVerify(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
        setLoading(false);
      }finally {
        setRefreshLoading(false);
      }
    }
    setLoading(false);
  };


  const VerifyDobForrefresh = async ( ) => {
    // Set the refresh loading state to true before starting the operation
    const data = location.state?.data;

    setRefreshLoading(true);
    setLoading(true);
    let isValid = true;
     // Always use the persistent DOB value
     const dob = persistentDob || localStorage.getItem('applicationDob');
     
     
     console.log("persistentDob ", dob);
     console.log("dobVerificationData ", dobVerificationData);

    if (!dob) {
      console.log("persistentDob  exist butt error ", dob);
      handleError("Please insert date of birth", "Dob");
      isValid = false;
      setLoading(false);
      setRefreshLoading(false);
    }
    if (isValid) {
      try {
         // Make sure we're using the persistent DOB in our API call
          const dataToSend = {
      ...data,
      Dob: dob
    };

    console.log("vdataToSend dataToSend")
    

        const response = await APIService.Post(
          // `/SelectionProcess/VerifyDateOfBirth`,
          `/SelectionProcess/ApplicantDobVerification`,
          dataToSend 
        );
        console.log("responseCode", response.responseCode);
        if (response.responseCode === 1) {
          setStudentData(response.dataSet);
          //
          // setPaymentFormData({
          //   ...PaymentFormData,
          //   Amount: response.dataSet.classAmount,
          // });
          getEMIPlans(response.dataSet && response.dataSet.classAmount); 
          setVerify(true);
          setLoading(false);
          
        }
      } catch (error) {
        console.error("Error fetching company data:", error);
        setLoading(false);
         // Show an error message to the user
         setModalTitle("Verification Required");
         setModalMessage("We need to verify your date of birth again to continue. Please enter your date of birth and click the Verify button.");
      setModalSeverity("error");
      setModalVisible(true);
      }finally {
        setRefreshLoading(false);
      }
    }
    setLoading(false);
  };

 

  // useEffect(() => {
  //   if (StudentData) {
  //     setPaymentFormData({
  //       ...PaymentFormData,

  //       BillingAddress: StudentData.applicationDetails.address1,
  //       BillingCity: StudentData.applicationDetails.city,
  //       BillingState: StudentData.applicationDetails.stateDesc,
  //       BillingZip: StudentData.applicationDetails.postCode,
  //       BillingCountry: StudentData.applicationDetails.country,
  //     });
  //   }
  // }, [StudentData]);

  const makePayment = async (e) => {
    e.preventDefault();
    console.log("makePayment");
    setLoading(true);
    let isValid = true;

    // let applicationNo = StudentformData.no;
    let BillingTel = PaymentFormData.BillingTel;
    let BillingEmail = PaymentFormData.BillingEmail;
    let Amount = PaymentFormData.Amount;
    let paymentOption = PaymentFormData.paymentOption;

    if (!BillingTel) {
      handleError("Please input mobile number", "BillingTel");
      isValid = false;
    }
    if (!BillingEmail) {
      handleError("Please input Email", "BillingEmail");
      isValid = false;
    }

    if (!Amount) {
      handleError("Please input Amount", "Amount");
      isValid = false;
    }

    if (!paymentOption) {
      handleError("Please select payment option", "paymentOption");
      isValid = false;
    }

    if (isValid) {
      try {
        const response = await APIService.Post(
          `/CCAvenuePayment/admissionFeePaymentInitiate`,
          PaymentFormData
        );
        console.log("response", response);
        if (response.responseCode === 1) {
          console.log("response", response);
          setLoading(false);

          // initiateTransaction(response.dataSet);
          // navigate("/Payment", {
          //   state: { data: "/entranceExamResult" },
          //   replace: true,
          // });
          navigate("/Payment", {
            state: {
              data: response.dataSet,
              link: "/entranceExamResult",
              status: "payment",
            },
            replace: true,
          });
        }
      } catch (error) {
        showToast("error", error.response.data.responseMessage);
      }
    }
    setLoading(false);
  };


    const handleEMIPaymentButtonClick = () => {
      let isValid = true;
      const mobile = PaymentFormData.BillingTel;
      const email = PaymentFormData.BillingEmail;
      const amount = PaymentFormData.Amount;
 
      // console.log("ApplicationData.classAmount",StudentData.classAmount);
    
  
      if (amount === 0 || amount === "0" || amount === "") {
        handleError("Please input Amount", "Amount");
        setError(true);
        isValid = false;
      }
  
      if (amount >StudentData.classAmount) {
        handleError("Amount should be less than due amount or equal", "Amount");
 
        setError(true);
        isValid = false;
        return;
      }


      if (!mobile) {
        handleError("Please input mobile number", "BillingTel");
        isValid = false;
      }
      if (!email) {
        handleError("Please input Email", "BillingEmail");
        isValid = false;
      }
  
    // console.log("StudentData",StudentData);
  
    console.log("email 202555555", email); 
  
      if (isValid) {
        if (window.GqErpSDK) {
          window.GqErpSDK.setOptions({
            env: process.env.REACT_APP_GQ_MODE,
            auth: {
              client_id: process.env.REACT_APP_GQ_CLIENT_ID,
              client_secret: process.env.REACT_APP_GQ_SECRET_KEY,
              api_key: process.env.REACT_APP_GQ_API_KEY
            },
            reference_id: "GQ_" + StudentData && StudentData.order_id, //"JUDE_REF_ID_004", // Client Order Id (Reference ID)
            student_id: StudentData &&  StudentData.applicationDetails.no, //'GQ_STUDENT_004', // Mandatory Parameter
            customer_mobile: removeCountryCode(mobile), // '9746680005', // Mandatory Parameter
            // customer_email: email, // Mandatory Parameter
            pp_config: {
              slug:process.env.REACT_APP_GQ_SLUG,
            },
            fee_headers: {
              // "emi_ payable ": amount
              total_payable: amount, //150000,
              //  "current_payable":amount,// 150000
            },
            customer_details: {
              customer_email: email,
            },
            notes: {
              "unique_number":StudentData && StudentData.order_id,// "ecd90e5d-02fb-4150-bb59-2d51800a5478" // Client Customized Object
              orderNo: "GQ_" + (StudentData && StudentData.order_id),
              academic_year:StudentData && StudentData.applicationDetails.academicYear,
              class_code: "",
              AppNo:StudentData &&  StudentData.applicationDetails.no,
              StudNo: StudentData &&  StudentData.applicationDetails.no,
              total_due: amount,
              payment_for: "Admission", //Admission Fees
              class: StudentData && StudentData.class_Description,
              "school": "St.Jude's Public School",
              "board": StudentData &&  StudentData.applicationDetails.curriculumInterested,
              "location":"Kotagiri",
              "platform": "St.Jude's Quick Online Payment Portal",
              "program": "Admission"
  
            },
            customizations: {
              logo_url: "https://www.stjudesonline.in/common/footerlogo.png",
              theme: {
                theme_color: "#970f2f",
              },
            },
          });
          window.GqErpSDK.render();
        } else {
          console.error("GqErpSDK is not loaded yet");
        }
      }
    };



    const isPaymentEligible = () => {
      return [5, 8, 9, 10, 0].includes(
        StudentData &&  StudentData.prv_emi_status
      );
    };


    
  function getEMIStatus( ) {
    const blockedNumbers = [5, 8, 9, 10, 0];
    // const data = JSON.parse(localStorage.getItem("appData"));
    if (blockedNumbers.includes(   StudentData &&  StudentData.prv_emi_status)) {
      return ""; // Return empty string if input is blocked
    }

    if(StudentData===null || StudentData===undefined) {
      return ""; // Return empty string if input is blocked
    }
  
    return "EMI Application form has been successfully submitted, waiting for Approval from GrayQuest";
  }

  
  function isAmountEnable( ) { 
    if( StudentData &&  StudentData.isPartialPaymentStatus === 0) {
      return true;
    }else{
      return false;
    }
  }

   


    // Function to hide the modal
const hideModal = () => {
  setModalVisible(false);
  
  // If it was a success message, you might want to perform some action after closing
  if (modalSeverity === "success") {
      VerifyDobForrefresh();
    // For example, refresh payment data or redirect
    // refreshPaymentData();
    // or
    // navigate("/success-page");
  }

  if(modalSeverity === "info") {
    console.log("info 2025 pro")
    VerifyDobForrefresh();
  }



};
  




  return (
    
    <div className="main-page">
      {refreshLoading && <Preloader />}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PublicHeader breadcrumb={breadcrumb} title={"Entrance Exam Result"} />
      <div className="content-wrapper  mt-10">
        <div className="col-md-12  reg">
          <div className="box-header text-center">
            <h3 className="box-title">ADMISSION - FEE PAYMENT</h3>
          </div>

          <br />
          <div className="">
            <div className=" reg">
              {/* <div className="box-header">
                <h3 className="box-title">Information</h3>
              </div> */}
              <div className="">
                <div className="row">
                  <div className="col-12 md:col-12 xl:col-6">
                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Application No. :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.applicationNo} /{" "}
                        {ApplicationData && ApplicationData.academicYear}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Student Name :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.name}
                        {/* {ApplicationData.middleNameOfStudent
                          ? ` ${ApplicationData.middleNameOfStudent}`
                          : ""}
                        {ApplicationData.lastNameOfStudent
                          ? ` ${ApplicationData.lastNameOfStudent}`
                          : ""} */}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Father's Name :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.fatherName
                          ? `${ApplicationData && ApplicationData.fatherName}`
                          : ""}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mother's Name :
                      </label>
                      <label className="col-12 md:col-12 xl:col-8 col-form-label">
                        {ApplicationData && ApplicationData.motherName
                          ? `${ApplicationData && ApplicationData.motherName}`
                          : ""}
                      </label>
                    </div>
                  </div>
                  <div className="col-12 md:col-12 xl:col-6">
                    <h4 className="text-red m-0">
                      Enter the date of birth and verify to continue...
                    </h4>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4">
                        Date Of Birth
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>
                      </label>
                      <div className="col-12 md:col-12 xl:col-4">
                        <div className="input-group">
                          <input
                            type="date"
                            className="form-control form-control-sm"
                            id="Dob"
                            name="Dob"
                            value={dobVerificationData.Dob}
                            onChange={UserformDataChange}
                            // onBlur={handleDobBlur}
                            onFocus={() => handleError(null, "Dob")}
                          />
                        </div>
                        {error && UserformError.Dob && (
                          <div className="text-red">{UserformError.Dob}</div>
                        )}
                      </div>
                      <div className="col-12 md:col-12 xl:col-4">
                        <Button
                          label="Verify"
                          severity="danger"
                          icon="pi pi-check"
                          loading={loading}
                          onClick={VerifyDob}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Mobile Number{" "}
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>{" "}
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            className={`form-control form-control-sm ${
                              errors.BillingTel ? "is-invalid" : ""
                            }`}
                            placeholder="Mobile Number"
                            id="BillingTel"
                            name="BillingTel"
                            value={PaymentFormData.BillingTel}
                            onChange={PaymentformDataChange}
                            onFocus={() => handleError(null, "BillingTel")}
                          />
                        </div>
                        {errors.BillingTel && (
                          <div className="invalid-feedback">
                            Invalid mobile number
                          </div>
                        )}
                        {error && UserformError.BillingTel && (
                          <div className="text-red">
                            {UserformError.BillingTel}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Email{" "}
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>{" "}
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="tel"
                            className={`form-control form-control-sm ${
                              errors.BillingEmail ? "is-invalid" : ""
                            }`}
                            placeholder="Email"
                            id="BillingEmail"
                            name="BillingEmail"
                            value={PaymentFormData.BillingEmail}
                            onChange={PaymentformDataChange}
                            onFocus={() => handleError(null, "BillingEmail")}
                          />
                        </div>
                        {errors.BillingEmail && (
                          <div className="invalid-feedback">
                            Invalid email address
                          </div>
                        )}
                        {error && UserformError.BillingEmail && (
                          <div className="text-red">
                            {UserformError.BillingEmail}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-12 md:col-12 xl:col-4 col-form-label">
                        Amount{" "}
                        <i aria-hidden="true" style={{ color: "red" }}>
                          *
                        </i>{" "}
                        :
                        <br />
                        <b className="text-red">
                          (Total Due : <span>&#8377;</span> {/* ₹ */}{" "}
                          {StudentData && formatNumber(StudentData.classAmount)}
                          )
                        </b>
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <div className="input-group">
                          <input
                            type="number"
                            className={`form-control form-control-sm ${
                              errors.Amount ? "is-invalid" : ""
                            }`}
                            placeholder="Amount"
                            style={isAmountEnable() ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                            id="Amount"
                            name="Amount"
                            value={PaymentFormData.Amount}
                            onChange={PaymentformDataChange}
                            onFocus={() => handleError(null, "Amount")}
                            disabled={ isAmountEnable()}
                          />
                        </div>
                        {error && UserformError.Amount && (
                          <div className="text-red">{UserformError.Amount}</div>
                        )}
                      </div>
                    </div>
                 

         {/* Gq and CCav 2025 */}

                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        // style={{ fontWeight: "400" }}
                      >
                        Payment Methods
                      </label>
                    </div>
                   
                    <div className="row mb-3  ">
                      <div className="col-10">
                        {/* <label>Payment Methods</label> */}
                        <div className="payment-methods row row-cols-1 row-cols-md-2 g-3 mt-2 ">
                          {/* Payment Method 1 - GrayQuest */}
                          {/* <div
                            className="col d-flex "
                            onClick={() => handleCardClick("grayQuest")}
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="payment-method card position-relative d-flex flex-column h-100 w-100 bg-white"
                              style={{
                                border:
                                  paymentMethodData.paymentMethod ===
                                  "grayQuest"
                                    ? "2px solid #93c7de"
                                    : "1px solid #dee2e6",
                              }}
                            >
                              
                              <img
                                src={NewArv}
                                alt="GrayQuest"
                               
                                style={{
                                  width: "75px",
                                  height: "auto",
                                  left: "-111px",
                                  top: "-28px",
                                  position: "relative",
                                }}
                              />
 

                          
                              <RadioButton
                                inputId="grayQuest"
                                name="paymentOption"
                                
                                style={{
                                  top: "0px",
                                  left: "-150px",
                                  position: "relative",
                                }}
                                value="grayQuest"
                                checked={
                                  paymentMethodData.paymentMethod ===
                                  "grayQuest"
                                }
                                onChange={() => handleCardClick("grayQuest")}
                              />
 
                              <div className="d-flex mt-1 ml-5">
                                <img
                                  src={grayQuestLogo}
                                  alt="GrayQuest"
                                  style={{ width: "200px", height: "auto",position: "relative" ,top: "-30px",left: "-10px" }}
                                />
                              </div>
                              
                             
                              <p className="small text-secondary text-center"  style={{ fontSize: "smaller",position: "relative",top: "-55px",left: "15px" }}>
                                Pay as low as{" "}
                                <span className="fw-bold text-dark font-weight-bold">
                                  Rs.{" "}
                                  {formatNumberWithCommas(
                                    totalEMIAmount && totalEMIAmount
                                  )}
                                </span>{" "}
                                per month
                              </p>

                               
                              <div
                                className="mt-auto text-center p-0"
                                style={{
                                  backgroundColor: "#f3f1ff",
                                  borderTop: "none",
                                  borderRadius: "0 0 8px 8px",
                                  position: "relative",
                                  bottom: "-15px",
                                  padding: "5px",
                                }}
                              >
                                <p className="small text-primary m-0" style={{ fontSize: "smaller" }}>
                                  Pay in small, convenient monthly payments
                                </p>
                              </div>
                            </div>
                          </div> */}

                          {/* Payment Method 2 - CCAvenue */}
                          <div
                            className="col d-flex"
                            onClick={() => handleCardClick("ccAvenue")}
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="payment-method card p-3 position-relative d-flex flex-column h-100 w-100 bg-white"
                              style={{
                                border:
                                  paymentMethodData.paymentMethod === "ccAvenue"
                                    ? "2px solid #93c7de"
                                    : "1px solid #dee2e6",
                              }}
                            >
                              {/* Radio Button */}
                              <RadioButton
                                inputId="ccAvenue"
                                name="paymentOption"
                                // className="position-absolute"
                                style={{
                                  top: "12px",
                                  left: "-111px",
                                  position: "relative",
                                }}
                                value="ccAvenue"
                                checked={
                                  paymentMethodData.paymentMethod === "ccAvenue"
                                }
                                onChange={() => handleCardClick("ccAvenue")}
                              />
 
                              {/* Payment Logo */}
                              <div className="d-flex mt-1 ml-4" style={{ position: "relative", top: "-15px", left: "-25px"}}>
                                <img
                                  src={ccAvenueLogo}
                                  alt="CCAvenue"
                                  style={{ width: "135px", height: "auto" }}
                                />
                              </div>

                              {/* Payment Options */}
                              <div className="payment-options  w-100 ">
                                {ccAvenuePaymentOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    className="form-check d-flex  ml-5"
                                    style={{ marginBottom: "7px" }}
                                  >
                                    <RadioButton
                                      inputId={option.value}
                                      name="paymentOption"
                                      value={option.value}
                                      onChange={PaymentformDataChange}
                                      checked={
                                        PaymentFormData.paymentOption ===
                                        option.value
                                      }
                                      onFocus={() => handleError(null, "paymentOption")}
                                      // onFocus={() =>
                                      //   handleError(null, "paymentOption")
                                      // }
                                    />
                                    <label className="form-check-label ms-2 ml-2">
                                      {option.label}
                                    </label>
                                  </div>
                                ))}
                
                
                {error && UserformError.paymentOption && (
                          <div className="text-red">
                            {UserformError.paymentOption}
                          </div>
                        )}

                          
                              </div>
                            </div>
                          </div>
                        </div>

               
                      </div>
                    </div>

                    <div className="d-flex justify-content-end align-items-center gap-3">
                      {paymentMethodData.paymentMethod !== "grayQuest" ? (
                        
                        <button
                          className="btn btn-info btn-lg pull-right"
                          onClick={makePayment}
                          style={{
                            width: "250px",
                            backgroundColor: !isPaymentEligible() ? "#b8daff" : "",
                            borderColor: !isPaymentEligible()  ? "#b8daff" : "",
                            color: !isPaymentEligible() ? "#fff" : ""
                          }}
                          disabled={!isPaymentEligible()}
                        >
                          Make Payment
                        </button>
                      ) : (
                        

                        <button
                          className="btn btn-info btn-lg pull-right"
                          onClick={handleEMIPaymentButtonClick}
                          style={{
                            width: "250px",
                            backgroundColor: !isPaymentEligible() ? "#b8daff" : "",
                            borderColor: !isPaymentEligible()  ? "#b8daff" : "",
                            color: !isPaymentEligible() ? "#fff" : ""
                          }} 
                          disabled={!isPaymentEligible()}
                        >
                          Pay In EMIs
                        </button>
                      )}
                    </div>


                    <div className="d-flex justify-content-end align-items-center ">
                    <p   className="  pull-right  " style={{ fontSize: "12px" ,fontWeight:"bold",color:"red" }} >{getEMIStatus()}</p>
                    </div>

                    {/* Gq and CCav 2025 */}

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GrayQuestModal
        visible={modalVisible}
        onHide={hideModal}
        title={modalTitle}
        message={modalMessage}
        severity={modalSeverity}
/>

    </div>
  );
}

export default RegPay;
